<template>
  <div id="list-video" class="list-dispo">
    <div class="modal-content">
      <div class="modal-body list_video_content" id="list_video">
        <div id="search-list" class="search-wrapper-list">
          <b-row>
            <b-col>
              <b-input-group>
                <b-form-input
                  :placeholder="$t('placeholder.search')"
                  id="inputVideoSearch"
                  class="searchInput"
                  v-on:keyup.enter="searchVideo()"
                ></b-form-input>
                <b-input-group-append>
                  <b-button v-on:click="searchVideo()" class="searchIcon" variant="secondary"
                    ><i class="fa fa-search"></i
                  ></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col v-show="showSelect">
              <b-form-select class="mb-3" v-model="idSelectedTheme" @change="onChangeThemId()">
                <template slot="first">
                  <option
                    v-for="option in this.options"
                    :value="option.title"
                    :key="option.id"
                    v-bind:value="option.id"
                  >
                    {{ option.title }}
                  </option>
                </template>
              </b-form-select>
            </b-col>
          </b-row>
        </div>

        <div class="flex">
          <div v-for="(video, index) in all_video" class="video-wrapper">
            <div
              v-bind:class="[
                'video-tag',
                {
                  'is-selected-video':
                    selected_vid === video.id || (!selected_vid && isSelected(video)),
                },
              ]"
            >
              <div class="image-card" v-on:click="SelectVideo(video)">
                <div class="image-card__video">
                  <img v-if="video.logo" :src="video.logo" :id="video.id" class="img-liste-dispo" />
                  <img
                    v-else
                    :src="defaultScreenshot"
                    alt="alt_img"
                    :id="video.id"
                    class="img-liste-dispo"
                  />
                </div>
                <div :title="video.title" class=" image-card__infos__title">
                  {{ video.title }}
                </div>
                <div :title="video.duration" class=" image-card__infos__duration duration-style">
                  {{ duration(video.duration) }}
                </div>
                <img
                  src="/display/static/images/tick.svg"
                  class="tick-img"
                  v-show="selected_vid === video.id || (!selected_vid && isSelected(video))"
                />
              </div>
            </div>
          </div>
        </div>
        <div id="loader-liste-dispo" class=" center">
          <span>
            <infinite-loading spinner="bubbles"></infinite-loading>
          </span>
        </div>
      </div>

      <div class="modal-footer footer-content">
        <button
          :class="['btn btn-link', 'footer-select-button']"
          v-on:click="DeselectVideo()"
          :disabled="disabledSelectButton || isSelected(videoGeneric)"
        >
          {{ $t('button.deselect') }}
        </button>
        <button
          :class="['btn btn-primary', 'footer-select-button']"
          v-on:click="addGeneriqueVideo()"
          :disabled="disabledSelectButton || isSelected(videoGeneric)"
        >
          {{ $t('button.select') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { HTTP } from '../../core/http/http-token';
import Routing from '../../core/router/router';
import storage from '../../storages.js';
import { mapGetters, mapActions } from 'vuex';
import en from '../../i18n/en_US';
import fr from '../../i18n/fr_FR';
import mixin from '../../mixins/Mixin.js';
import InfiniteLoading from 'vue-infinite-loading';

export default {
  mixins: [mixin],
  data() {
    return {
      idSelectedTheme: [],
      showSelect: false,
      selected_vid: '',
      all_video: [],
      page: 0,
      total_number: 0,
      defaultScreenshot: '/display/static/images/play_thumbnail.svg',
      indexvideo: '',
      disabledSelectButton: true,
      videoGeneric: {},
      searchTitle: '',
      screenType: '',
      genericType: '',
      themId: 0,
      options: [],
    };
  },
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  mixins: [mixin],
  mounted() {
    this.optionSelect();
  },

  created() {
    var self = this;
    self.reloadVideoList(1);
  },

  computed: {
    /**
     * Getters from Vuex Store
     */
    ...mapGetters({
      dispositions: 'dispositions/getAll',
      paramsClient: 'getParamsClients',
      getAllSelected: 'segments/getAllSelected',
      getAllSelectedSlides: 'slides/getAllSelected',
      getGenericThem: 'common/getGenericThem',
      getOptionsThemeSelect: 'common/getOptionsThemeSelect',
    }),
  },
  components: {
    InfiniteLoading,
  },
  methods: {
    ...mapActions(['pushScreen']),
    ...mapActions('slides', ['setSlidesGeneric']),
    ...mapActions('segments', ['setSegmentsGeneric', 'setVideoIntro']),
    ...mapActions({
      setSelectedVideo: 'common/setSelectedVideo',
      searchGenericVideo: 'common/searchGenericVideo',
    }),
    ...mapActions('common', ['setGenericThem']),
    hasStartGeneric(segment) {
      return segment.screens.some(s => s.type === 'startGeneric');
    },
    duration(duration) {
      return this.getDuration(duration);
    },
    isSelected(video) {
      var generic = document.getElementById('list_videos').getAttribute('generic');
      const index = document.getElementById('list_videos').getAttribute('data-index');
      if (this.$route.name === 'segment') {
        if (generic === 'debut') {
          const startGeneric = this.getAllSelectedSlides.find(s => s.type === 'startGeneric');
          if (startGeneric) {
            this.disabledSelectButton = false;
            return startGeneric.html.indexOf(video.lien) > -1;
          }
        }
      } else {
        if (generic === 'debut') {
          const startGeneric = this.getAllSelected.find(s => s.type === 'startGeneric');
          if (startGeneric) {
            this.disabledSelectButton = false;
            return (
              startGeneric.screens[0].html.indexOf(video.lien) > -1 ||
              (video.lienMp4 &&
                startGeneric.screens[0].html.indexOf(
                  video.lienMp4.substring(0, video.lienMp4.length - 13),
                ) > -1)
            );
          }
        } else if (generic === 'fin') {
          const finishGeneric = this.getAllSelected.find(s => s.type === 'finishGeneric');
          if (finishGeneric) {
            this.disabledSelectButton = false;
            return (
              finishGeneric.screens[0].html.indexOf(video.lien) > -1 ||
              (video.lienMp4 &&
                finishGeneric.screens[0].html.indexOf(
                  video.lienMp4.substring(0, video.lienMp4.length - 13),
                ) > -1)
            );
          }
        } else if (generic === 'intro') {
          const introGeneric = this.getAllSelected[index].screens.find(
            s => s.type === 'startGeneric',
          );
          if (introGeneric) {
            this.disabledSelectButton = false;
            return (
              introGeneric.html.indexOf(video.lien) > -1 ||
              (video.lienMp4 &&
                introGeneric.html.indexOf(video.lienMp4.substring(0, video.lienMp4.length - 13)) >
                  -1)
            );
          }
        }
      }
    },
    SelectVideo(video) {
      let videoObj = {
        lien: video.lien,
        lienMp4: video.lienMp4,
        id: video.id,
        logo: video.logo,
        title: video.title,
        duration: video.duration,
      };
      this.videoGeneric = videoObj;
      this.selected_vid = this.videoGeneric.id;
      this.disabledSelectButton = false;
    },
    DeselectVideo() {
      let videoObj = {
        lien: '',
        lienMp4: '',
        id: '',
        logo: '',
        title: '',
        duration: '',
      };
      this.videoGeneric = videoObj;
      this.selected_vid = '';
      this.disabledSelectButton = true;
      this.addGeneriqueVideo();
    },

    addGeneriqueVideo() {
      var self = this;
      var generic = document.getElementById('list_videos').getAttribute('generic');
      const index = document.getElementById('list_videos').getAttribute('data-index');
      let display_default_blocks = this.paramsClient.display_default_blocks;
      let src = this.videoGeneric.lien;
      if (display_default_blocks && display_default_blocks.length > 0) {
        let blocks = display_default_blocks.map(block => {
          return block.blocks;
        });
        blocks.forEach(block => {
          for (let i = 0; i < block.length; i++) {
            if (block[i] === 'video_mp4') {
              src = this.videoGeneric.lienMp4;
            }
          }
        });
      }
      const slide = {
        src: src,
        title: 'generique ' + generic + ' ' + self.makeId(),
        logo: this.videoGeneric.logo,
        options: {
          duration: this.videoGeneric.duration,
        },
        originalDuration: this.videoGeneric.duration,
      };
      if (generic === 'intro') {
        slide.type = 'startGeneric';
        slide.index = index;
        self.setVideoIntro(slide);
      } else {
        if (generic === 'debut') {
          slide.type = 'startGeneric';
        } else {
          slide.type = 'finishGeneric';
        }
        if (self.$route.name === 'segment') {
          self.setSlidesGeneric(slide);
        } else {
          self.setSegmentsGeneric(slide);
        }
      }

      self.selected_vid = this.videoGeneric.id;
      this.$root.$emit('closeModal');
    },

    reloadVideoList() {
      var self = this;
      self.page = self.page + 1;
      let params = {};
      if (this.getGenericThem == 0) {
        params = {
          id: '',
          page: self.page,
          nbParPage: 20,
          client: localStorage.getItem('client'),
        };
      } else {
        this.themeId = this.getGenericThem;
        params = {
          id: '',
          page: self.page,
          nbParPage: 20,
          idTheme: this.themeId,
          client: localStorage.getItem('client'),
          maxBitrate: true,
        };
      }

      if (this.searchTitle) {
        params.searchWord = this.searchTitle;
      }
      HTTP(window.ApiToken)
        .get(Routing.generate('api_media_get_media', params))
        .then(
          function(response) {
            document.getElementById('loader-liste-dispo').style.visibility = 'hidden';
            if (response.data.code === 200) {
              if (response.data) {
                self.total_number = self.total_number + response.data.medias.length;
                self.all_video = self.all_video.concat(response.data.medias);
                var listElm = document.getElementById('list_video');
                listElm.onscroll = function() {
                  if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
                    if (self.all_video.length < response.data.nombre_total) {
                      document.getElementById('loader-liste-dispo').style.visibility = 'visible';
                      self.reloadVideoList();
                    } else {
                      document.getElementById('loader-liste-dispo').style.visibility = 'hidden';
                    }
                  }
                };
              }
            }
          },
          function(response) {
            //self.hideLoader();
          },
        );
    },
    searchVideo() {
      var title = document.getElementById('inputVideoSearch').value;
      this.searchTitle = title;
      this.page = 0;
      this.all_video = [];
      this.searchGenericVideo(title);
      this.reloadVideoList(this.themeId);
      document.getElementById('loader-liste-dispo').style.visibility = 'visible';
    },
    btnConfirm() {
      var self = this;
      self.close();
    },

    optionSelect() {
      if (this.getOptionsThemeSelect.length != 0) {
        this.options = this.getOptionsThemeSelect;
        this.idSelectedTheme = this.options[0].id;
        if (this.options.length > 1) this.showSelect = true;
      }
    },
    onChangeThemId() {
      this.setGenericThem(this.idSelectedTheme);
      this.all_video = [];
      this.page = 0;
      this.reloadVideoList();
      document.getElementById('loader-liste-dispo').style.visibility = 'visible';
    },
  },
};
</script>

<style lang="scss" scoped>
.success-dispo {
  background: rgb(59, 151, 227);
  border: none;
  width: 159px;
  height: 47px;
  font-size: larger;
  color: rgb(255, 255, 255);
  border-radius: 3px;
  margin-bottom: 25px;
  margin-top: 20px;
  margin-right: -75%;
  cursor: pointer;
}
.list_video_content {
  text-align: center;
  max-height: 560px;
  overflow-y: scroll;
  padding-top: 20px;
  background: #ffffff;
  padding: 10px 10px !important;
}
.footer-content {
  height: 50px;
  padding: 2rem 1.5rem !important;
}
.list-dispo {
  background: #e3e6ed;
}

.img-liste-dispo {
  width: 204px;
  height: 115px;
  position: relative;
  min-width: 180px;
  overflow: hidden;
  min-width: 100%;
  border-radius: 3px;
  object-fit: cover;
}
.video-tag {
  position: relative;
  margin: 10px !important;
  width: 204px;
  height: 115px;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
  float: left;
  cursor: pointer;
  border-radius: 3px;
  &:hover {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16), 2px 4px 6px rgba(0, 0, 0, 0.23);
    background: rgba(26, 147, 240, 0.6);
    .image-card {
      background: rgba(26, 147, 240, 0.6);
      z-index: 1;
      &__infos {
        &__title {
          z-index: 1;
        }
        &__duration {
          z-index: 1;
        }
      }
    }
  }
  &.is-selected-video {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16), 2px 4px 6px rgba(0, 0, 0, 0.23);
    .image-card {
      &__infos {
        &__title {
          background: none;
          z-index: 1;
        }
        &__duration {
          z-index: 1;
        }
      }
    }
    .tick-img {
      display: block;
    }
    &:before {
      background: rgba(26, 147, 240, 0.6);
      z-index: 1;
    }
  }
  &:before {
    content: '';
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    transition: 0s ease-in-out;
  }
}
.video-wrapper {
  flex: 0 0 25%;
  justify-content: center;
  display: flex;
  flex-direction: column;
  padding: 0 3px;
  @media screen and (max-width: 1077px) and (min-width: 815px) {
    flex: 0 0 33.33%;
  }
  @media screen and (max-width: 815px) {
    flex: 0 0 50%;
  }
}
.list_video {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  min-height: 100px;
  max-height: 660px;
  overflow-y: auto;
  overflow-x: hidden;
}
.selected-video {
  background-color: rgba(255, 255, 255, 0.1);
  opacity: 0.6;
}
#search-list {
  width: 98.2%;
  padding-left: 12px;
  &:hover {
    border: 1px;
  }
}
.search-images {
  position: absolute;
  border: none;
  background-color: #ffffff;
  color: #7c7c7c;
  border-color: #7c7c7c;
}
.image-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  &__video {
    width: 100%;
    position: absolute;
    display: flex;
    flex-direction: row;
    top: 0;
  }
  &__infos {
    position: absolute;
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 20%;
    bottom: 0;
    &__title {
      float: left;
      text-align: left;
      position: absolute;
      width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      font-size: 13px;
      color: white;
      font-weight: bold;
      background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);
      padding: 0.5em;
      height: 4em;
    }
    &__duration {
      float: left;
      position: absolute;
      left: 8px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      font-size: 12px;
      padding: 2px 3px !important;
      bottom: 8px;
    }
  }
}
.list-generic-videos {
  width: 100%;
  height: 360px;
  display: flex;
  flex-wrap: wrap;
}

.searchIcon {
  border: 1px solid #ced4da !important;
  border-left: none;
  background-color: #ffffff !important;
  color: #ced4da !important;
  font-size: 13px !important;
  &:focus {
    border: 1px solid #ced4da !important;
  }
}
.searchInput {
  border-right: none;
  font-size: 16px !important;

  &:focus {
    border: 1px solid #ced4da !important;
  }
}
#inputVideoSearch::placeholder {
  font-size: 16px;
}
.search-wrapper-list {
  position: relative;
  text-align: left;
  padding: 5px;

  input {
    padding: 6px 12px;
    color: rgba(0, 0, 0, 0.7);
    border: 1px solid rgba(0, 0, 0, 0.12);
    transition: 0.15s all ease-in-out;
    background: transparent;

    border-radius: 5px;
    &:focus {
      outline: none;
    }
    &::-webkit-input-placeholder {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.5);
      font-weight: 100;
    }
  }
}
.footer-select-button {
  padding: 10px 1.5rem !important;
  font-size: 14px !important;
}
.flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: start;
}
.duration-style {
  background: #919ba5;
  border-radius: 3px;
  justify-content: center;
  color: #ffffff;
}
.tick-img {
  width: 24px;
  height: 24px;
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 1;
  margin: 8px;
  display: none;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// ListVideo.vue?650b11cd